import dayjs from 'dayjs'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import CloseIcon from '../../../assets/icons/JSX/CloseIcon'
import Colors from '../../../assets/styles/Colors'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import BirthDayInput from '../../../components/v2/BirthDayInput'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import AddButton from '../../../components/v2/buttons/AddButton'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import { useAppDispatch, useAppSelector } from '../../../store'
import {
  TravelAbroadState,
  addEmptyTraveler,
  removeTravelerAtIndex,
  updateTravelerAtIndex,
} from '../../../store/travelAbroadSlice'
import AbroadProgressBar from '../../../components/v2/progrees-bars/AbroadProgressBar'
import { Helmet } from 'react-helmet-async'
//
//
const AddTravelers = () => {
  //
  //
  const dispatch = useAppDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { travelAbroad: TravelAbroadState }) => data.travelAbroad)
  //
  //
  const { t } = useTranslation()
  //
  //
  const navigate = useNavigate()
  //
  //
  //
  //
  const isDataValid = (data: any) => {
    if (!Array.isArray(data)) {
      return false
    }

    for (let i = 0; i < data.length; i++) {
      const item = data[i]
      if (
        item.age === null ||
        item.age === 0 ||
        item.date === null ||
        item.date.length !== 14 ||
        Number(item.age) < 0
      ) {
        return false
      }
    }

    return true
  }
  //
  //
  const [getLeftCompanies, { data: leftCompanies }] = api.useTravelAbrodLeftCompaniesMutation()
  //
  useEffect(() => {
    if (
      filter.productCategory &&
      filter.singleOrMulti &&
      filter.travelersDate &&
      filter.travelersDate !== undefined &&
      filter.travelersDate.length >= 1 &&
      isDataValid(filter.travelersDate) &&
      filter.region &&
      filter.currency &&
      ((filter.singleDates?.start && filter.singleDates?.end) ||
        (filter.multiDates?.start && filter.multiDates?.end && filter.multiDays?.days))
    ) {
      const GetCompaniesFunction = async () => {
        try {
          //
          await getLeftCompanies({
            step: 'step-six',
            productCategory: filter.productCategory,
            startDate:
              filter.singleOrMulti === 'single-travel'
                ? (filter.singleDates?.start as string)
                : (filter.multiDates?.start as string),
            endDate:
              filter.singleOrMulti === 'single-travel'
                ? (filter.singleDates?.end as string)
                : (filter.multiDates?.end as string),
            multiDay: filter.singleOrMulti === 'single-travel' ? null : (filter.multiDays?.days as number),
            travelType: filter.singleOrMulti,
            currency: filter.currency,
            limit: filter.limit as number,
            area: filter.region,
            ages: filter.travelersDate?.map((item) => (item.month === null ? item.age : 0)),
          }).unwrap()
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          } else {
            toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (GetCompaniesFunction) (AddTravelers)')
          }
        }
      }
      //
      GetCompaniesFunction()
    }

    return () => {}
  }, [
    filter.productCategory,
    filter.singleOrMulti,
    filter.multiDates?.start,
    filter.multiDates?.end,
    filter.multiDays?.days,
    filter.region,
    filter.singleDates?.start,
    filter.singleDates?.end,
    filter.currency,
    filter.limit,
    filter.travelersDate,
    getLeftCompanies,
  ])
  //
  //
  const maxAgeValidation = (travelers: any) => {
    for (const traveler of travelers) {
      if (traveler >= 123) {
        return false
      }
    }
    return true
  }
  //
  //
  const calculateAge = (birthDate: string) => {
    const now = dayjs()
    const birth = dayjs(birthDate)
    const years = now.diff(birth, 'year')
    birth.add(years, 'year')
    const months = now.diff(birth, 'month')
    return { years, months }
  }
  //
  //
  return (
    <Wrapper>
      <Helmet>
        <title>{t('travelersAgeTitle')}</title>
        <meta name="description" content={`${t('travelersAgeTitle')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={t('travelersAgeTitle')} />

        <AbroadProgressBar stepName={`${t('dateOfBirth')}`} />

        <Block>
          {filter.travelersDate?.map((item, index) => {
            return (
              <WhiteBox key={index}>
                <RemoveBtn onClick={() => dispatch(removeTravelerAtIndex(index))}>
                  <CloseIcon />
                </RemoveBtn>

                <BirthDayInput
                  id="test"
                  label={`${t('traveler')} ${index + 1}`}
                  placeholder={t('dayMonthYear')}
                  value={item.date || ''}
                  width="fullWidth"
                  error={
                    item.date && item.date.length >= 8 && (item.date.match(/\//g) || []).length !== 2 ? true : false
                  }
                  errorText={`${t('invalidFormat')}`}
                  onChange={(value: string) => {
                    const [day, month, year] = value.split(' / ')

                    // Create a new Date object from the provided date
                    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day))

                    // Get the current date
                    const currentDate = new Date()

                    // Calculate the difference in years
                    let yearDifference = currentDate.getFullYear() - date.getFullYear()

                    // Calculate the difference in months
                    const monthDifference = currentDate.getMonth() - date.getMonth()

                    // Calculate the difference in days
                    const dayDifference = currentDate.getDate() - date.getDate()

                    // If the birthday for this year hasn't occurred yet, subtract 1 from the age
                    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
                      yearDifference--
                    }

                    // Convert the input date to the desired format
                    const dateParts = value?.split('/').map((part) => part.trim())
                    const formattedDate = dateParts && new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`)

                    // get diff age and month
                    const { months } = calculateAge(formattedDate as unknown as string)

                    const TrMonth = months >= 12 ? null : parseFloat(`0.${months}`)

                    // Dispatch the updated traveler data
                    if (true) {
                      dispatch(
                        updateTravelerAtIndex({
                          travelerIndex: index,
                          newValue: {
                            age: yearDifference === 0 ? 1 : yearDifference,
                            date: value,
                            dateFormat: dayjs(formattedDate).format('YYYY-MM-DD'),
                            month: TrMonth === 0 ? 0.1 : TrMonth,
                          },
                        }),
                      )
                    }
                  }}
                />
              </WhiteBox>
            )
          })}

          <RemainingCompanies
            style={{
              marginTop: '0px',
              opacity: leftCompanies ? '1' : '0',
            }}
            text={`${t('offerAvailable')}: ${leftCompanies?.length} `}
          />
        </Block>

        <AddButtonStyle>
          <AddButton text={t('addTraveler')} onClick={() => dispatch(addEmptyTraveler())} />
        </AddButtonStyle>

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/currency-and-limit')} />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={
              (isDataValid(filter.travelersDate) === true ? true : false) &&
              filter.productCategory &&
              filter.singleOrMulti &&
              filter.currency &&
              filter.limit &&
              leftCompanies &&
              leftCompanies.length >= 1 &&
              filter.region &&
              filter.travelersDate &&
              filter.travelersDate.find((x) => x.age !== 0) &&
              maxAgeValidation(filter.travelersDate?.map((x) => x.age)) &&
              filter.travelersDate.find((x) => x.date !== null) &&
              ((filter.multiDates?.start && filter.multiDates?.end && filter.multiDays?.days) ||
                (filter.singleDates?.start && filter.singleDates?.end))
                ? false
                : true
            }
            onClick={() => navigate('/choose-method')}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
const AddButtonStyle = styled.div`
  margin-top: 34px;
  display: grid;
  place-items: center;
`
const RemoveBtn = styled.button`
  border: unset;
  outline: none;
  background-color: transparent;
  position: absolute;
  top: 16px;
  right: 16px;
  margin-bottom: 5px;
  padding: 0px;
  height: 18px;
  width: 18px;
  display: flex;
  justify-content: center;
  align-items: center;

  /* svg */
  svg {
    width: 16px;
    height: 13px;
    color: ${Colors.nevadaGrey};
  }

  &:hover {
    opacity: 0.8;
  }

  ${Responsive.mobile} {
    top: 13px;
    right: 13px;
  }
`
const WhiteBox = styled.div`
  background-color: ${Colors.white};
  box-shadow: 0 4px 50px 0 ${Colors.shadow};
  border-radius: 8px;
  padding: 40px 48px;
  width: 100%;
  position: relative;

  ${Responsive.mobile} {
    padding: 30px 20px;
  }
`
const Block = styled.div`
  max-width: 464px;
  margin-inline: auto;
  margin-top: 32px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-row-gap: 24px;

  ${Responsive.mobile} {
    margin-top: 24px;
  }
`

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  width: 100%;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`
//
export default AddTravelers
